import cssHasPseudo from "../../node_modules/css-has-pseudo/dist/browser.mjs";
import "./popup.js";
import "./clicker.js";
import "./dialog.js";
import "./animations.js";
import "./imports.js";

cssHasPseudo(document);
